import { AlphaXBoxIcon } from './AlphaXBoxIcon';

/**
 * author: GreenTurtwig
 * id 25BBD26F-C8D4-4E4D-899C-57D910EECA55
 * name alpha-x-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-x-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterXBoxIcon = AlphaXBoxIcon;
export default LetterXBoxIcon